"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardDataArea = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCard = require("../PropertyCard/PropertyCard.context");
var _PropertyCardDataArea = require("./PropertyCardDataArea.styles");
var _excluded = ["children", "dataType", "level", "lineClamp"];
/**
 * Used for displaying property data in a `PropertyCard`. Provides text styles and the option
 * to truncate text.
 *
 * @extends Paragraph
 * @since 8.63.0
 */
var PropertyCardDataArea = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    dataType = _ref.dataType,
    level = _ref.level,
    lineClamp = _ref.lineClamp,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_PropertyCard.PropertyCardContext);
  return /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.StyledPropertyCardDataArea, (0, _extends2.default)({
    as: "div" /* Some tags (ex: <address>) can't be nested inside of a <p> so use <div> instead */,
    ref: forwardedRef,
    appearance: context.appearance,
    dataType: dataType,
    lineClamp: lineClamp
  }, rest), children);
});
exports.PropertyCardDataArea = PropertyCardDataArea;
PropertyCardDataArea.displayName = 'PropertyCard.DataArea';
PropertyCardDataArea.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Determines the text style.
   */
  dataType: _propTypes.default.oneOf(['title', 'body1', 'body2', 'body3', 'additionalInfo']),
  /**
   * Truncates text at the number of lines specified (with ellipses). Useful for helping a
   * Property Card maintain a fixed height.
   *
   * For no truncation, use `none`. (Jan 2022 note: `none` is not accepted in
   * Chrome/Saf/Edge even though the
   * [spec](https://www.w3.org/TR/css-overflow-3/#webkit-line-clamp) dictates that `none`
   * should be the initial value. So for now, we map `none` to `initial`.)
   */
  lineClamp: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
} : {};
PropertyCardDataArea.defaultProps = {
  dataType: 'title',
  lineClamp: 1
};